const Controls = {
  isUp: false,
  isDown: false,
  isLeft: false,
  isRight: false,
}

const keyDownListener = (e) => {
  switch(e.key) {
    case 'w':
    case 'ArrowUp':
      Controls.isUp = true
      break;
    case 's':
    case 'ArrowDown':
      Controls.isDown = true
      break;
    case 'a':
    case 'ArrowLeft':
      Controls.isLeft = true
      break;
    case 'd':
    case 'ArrowRight':
      Controls.isRight = true
      break;
    default:
      break;
  }
}

const keyUpListener = (e) => {
  switch(e.key) {
    case 'w':
    case 'ArrowUp':
      Controls.isUp = false
      break;
    case 's':
    case 'ArrowDown':
      Controls.isDown = false
      break;
    case 'a':
    case 'ArrowLeft':
      Controls.isLeft = false
      break;
    case 'd':
    case 'ArrowRight':
      Controls.isRight = false
      break;
    default:
      break;
  }
}

const initControls = () => {
  window.addEventListener('keydown', keyDownListener)
  window.addEventListener('keyup', keyUpListener)
}

const stopControls = () => {
  window.removeEventListener('keydown', keyDownListener)
  window.removeEventListener('keyup', keyUpListener)
}

export {
  initControls,
  stopControls,
  Controls
}